import { rowIdToLiveChartPeriod } from "@package/grid-utils";
import type { GetContextMenuSection } from "./helpers";
import { getIcon } from "./icons";
import { isNullish } from "remeda";
import { shouldDisableLiveChartForCustomerCurve } from "../../menu-system/live-chart-feeds";
import { useCurrentUser, useUserSubscriptionTier } from "../../../data/user";
import { useCurrentUserOrg } from "../../../context/auth/hooks";

// We want to disable live chart plotting of non-exchange curves for users in orgs other than OB and Gunvor (org IDs 12 and 10).
const orgExceptions = [12, 10];

export const useGetMenuItemsCharts = (): GetContextMenuSection => {
  const { disabledFeatures } = useUserSubscriptionTier();
  const user = useCurrentUser();
  const { data: orgData } = useCurrentUserOrg();
  const orgNeedsHistoricalData = orgData?.data?.organisation_by_pk?.needs_historical_data ?? false;
  const org = user?.data?.organisation;

  return (ctx) => {
    if (!ctx.isProduct) return [];

    const isExchangeCurve = ctx.artisType === "sourced";
    const isOrgException = !isNullish(org) && orgExceptions.includes(org);

    // Check if any cell in the selection is from a custom time spread
    const hasCustomTimeSpread = ctx.rangeSelection?.some((cell) => {
      const rowNode = ctx.api.getRowNode(cell.rowId);
      return rowNode?.data?.rowType === "adhoc";
    });

    const disabled =
      disabledFeatures?.plotLiveChart ||
      ctx.artisType === "eod" ||
      (!isExchangeCurve && !isOrgException) ||
      hasCustomTimeSpread ||
      shouldDisableLiveChartForCustomerCurve(ctx.artisType, orgNeedsHistoricalData);

    return [
      {
        name: "View Live Chart",
        disabled,
        tooltip: disabledFeatures?.plotLiveChart
          ? "Please upgrade your subscription to access this feature"
          : undefined,
        icon: getIcon("barChart"),
        action: () => {
          const cell = ctx.rangeSelection?.[0];
          if (!cell) return;

          const productId = cell?.productId;
          const rowId = cell?.rowId;
          if (!productId || !rowId) return;

          const month = rowIdToLiveChartPeriod(rowId);

          window.open(
            `/app/trading-chart/${productId}/${month}`,
            "_blank",
            "width=750,height=500,menubar=no,toolbar=no,location=no,scrollbars=no,status=no",
          );
        },
      },
    ];
  };
};
